<template>
	<!-- <div>
    <pui-text-field :label="$t('status')" v-model="longStatus" toplabel disabled></pui-text-field>
	</div>-->
	<div>
		<pui-select
			id="status"
			attached="status"
			:label="$t('status')"
			toplabel
			required
			clearable
			:disabled="disabled"
			v-model="modelComp"
			:items="statusCodes"
			:itemsToSelect="[{ code: statusColumn }]"
			:modelFormMapping="{ code: statusColumnName }"
			itemValue="code"
			itemText="text"
		></pui-select>
	</div>
</template>

<script>
export default {
	name: 'statusselectcomponent',
	props: {
		modelComp: {
			type: [String, Object],
			required: true
		},
		statusColumn: {
			type: [String],
			required: false
		},
		statusColumnName: {
			type: [String],
			required: true
		},
		disabled: {
			type: [Boolean],
			default: false
		}
	},
	data() {
		return {
			statusCodes: [
				{ code: 'P', text: this.$t('status.P') },
				{ code: 'C', text: this.$t('status.C') },
				{ code: 'D', text: this.$t('status.D') },
				{ code: 'R', text: this.$t('status.R') },
				{ code: 'E', text: this.$t('status.E') }
			]
		};
	},
	beforeUpdate() {
		this.$puiEvents.$on('onPuiSelect_selectedItems-status', newVal => {
			this.modelComp[this.statusColumnName] = newVal.model.code;								
		});
	},
	computed: {},

	methods: {}
};
</script>

<style></style>
